import { apiClient } from "./apiClient";

export const registerUser = async (userData) => {
  const response = await apiClient.post("/auth/register", userData);
  return response.data;
};

export const sendPhoneVerification = async (phone) => {
  const response = await apiClient.post("/auth/phone-verification/start", { phone });
  return response.data;
};

export const loginUser = async (credentials) => {
  const response = await apiClient.post("/auth/login", credentials);
  return response.data;
};

export const resendEmailVerification = async (email) => {
  const response = await apiClient.post("/auth/resend-verification", { email });
  return response.data;
};

export const verifyEmailSession = async (access_token) => {
  const response = await apiClient.post("/auth/verify-email", { access_token });
  return response.data;
};

export const forgotPassword = async (email) => {
  const response = await apiClient.post("/auth/forgot-password", { email });
  return response.data;
};


export const resetPassword = async (data) => {
  const response = await apiClient.post("/auth/reset-password", data);
  return response.data;
};

export const deleteAccount = async () => {
  const response = await apiClient.delete("/auth/delete");
  return response.data;
};
